module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/overlay.cde4ff60.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/overlay.png
// module id = 2541
// module chunks = 11